import { defineMessages } from "react-intl"

export default defineMessages({
  headerRemoteTesting: {
    id: "app.components.RemoteTesting.headerRemoteTesting",
  },
  remoteTesting: {
    id: "app.components.RemoteTesting.remoteTesting",
  },
  countries: {
    id: "app.components.RemoteTesting.countries",
  },
  provinces: {
    id: "app.components.RemoteTesting.provinces",
  },
  "canProvinces.Alberta": {
    id: "app.components.RemoteTesting.canProvinces.Alberta",
  },
  "canProvinces.BritishColumbia": {
    id: "app.components.RemoteTesting.canProvinces.BritishColumbia",
  },
  "canProvinces.Manitoba": {
    id: "app.components.RemoteTesting.canProvinces.Manitoba",
  },
  "canProvinces.NewBrunswick": {
    id: "app.components.RemoteTesting.canProvinces.NewBrunswick",
  },
  "canProvinces.Newfoundland": {
    id: "app.components.RemoteTesting.canProvinces.Newfoundland",
  },
  "canProvinces.NorthwestTerritories": {
    id: "app.components.RemoteTesting.canProvinces.NorthwestTerritories",
  },
  "canProvinces.NovaScotia": {
    id: "app.components.RemoteTesting.canProvinces.NovaScotia",
  },
  "canProvinces.Nunavut": {
    id: "app.components.RemoteTesting.canProvinces.Nunavut",
  },
  "canProvinces.Ontario": {
    id: "app.components.RemoteTesting.canProvinces.Ontario",
  },
  "canProvinces.PrinceEdwardIsland": {
    id: "app.components.RemoteTesting.canProvinces.PrinceEdwardIsland",
  },
  "canProvinces.Quebec": {
    id: "app.components.RemoteTesting.canProvinces.Quebec",
  },
  "canProvinces.Saskatchewan": {
    id: "app.components.RemoteTesting.canProvinces.Saskatchewan",
  },
  "canProvinces.YukonTerritory": {
    id: "app.components.RemoteTesting.canProvinces.YukonTerritory",
  },
  peripherals: {
    id: "app.components.RemoteTesting.peripherals",
  },
  "peripherals.PS": {
    id: "app.components.RemoteTesting.peripherals.PS",
  },
  "peripherals.Xbox": {
    id: "app.components.RemoteTesting.peripherals.Xbox",
  },
  "peripherals.HeadphonesWithMicrophone": {
    id: "app.components.RemoteTesting.peripherals.HeadphonesWithMicrophone",
  },
  "peripherals.Webcam": {
    id: "app.components.RemoteTesting.peripherals.Webcam",
  },
  "peripherals.EyeTracker": {
    id: "app.components.RemoteTesting.peripherals.EyeTracker",
  },
  "peripherals.VideoCaptureCard": {
    id: "app.components.RemoteTesting.peripherals.VideoCaptureCard",
  },
  "peripherals.VRDevice": {
    id: "app.components.RemoteTesting.peripherals.VRDevice",
  },
  internetSpeeds: {
    id: "app.components.RemoteTesting.internetSpeeds",
  },
  "internetSpeeds.0-9Mbps": {
    id: "app.components.RemoteTesting.internetSpeeds.0-9Mbps",
  },
  "internetSpeeds.10-20Mbps": {
    id: "app.components.RemoteTesting.internetSpeeds.10-20Mbps",
  },
  "internetSpeeds.21-40Mbps": {
    id: "app.components.RemoteTesting.internetSpeeds.21-40Mbps",
  },
  "internetSpeeds.41-100Mbps": {
    id: "app.components.RemoteTesting.internetSpeeds.41-100Mbps",
  },
  "internetSpeeds.>100Mbps": {
    id: "app.components.RemoteTesting.internetSpeeds.>100Mbps",
  },
  operatingSystems: {
    id: "app.components.RemoteTesting.operatingSystems",
  },
  "operatingSystems.Windows10": {
    id: "app.components.RemoteTesting.operatingSystems.Windows10",
  },
  "operatingSystems.Windows8orOlder": {
    id: "app.components.RemoteTesting.operatingSystems.Windows8orOlder",
  },
  "operatingSystems.MacOS": {
    id: "app.components.RemoteTesting.operatingSystems.MacOS",
  },
  "operatingSystems.Linux": {
    id: "app.components.RemoteTesting.operatingSystems.Linux",
  },
  "operatingSystems.ChromeOS": {
    id: "app.components.RemoteTesting.operatingSystems.ChromeOS",
  },
  "operatingSystems.Windows11": {
    id: "app.components.RemoteTesting.operatingSystems.Windows11",
  },
  specifications: {
    id: "app.components.RemoteTesting.specifications",
  },
  "specifications.Low": {
    id: "app.components.RemoteTesting.specifications.Low",
  },
  "specifications.Average": {
    id: "app.components.RemoteTesting.specifications.Average",
  },
  "specifications.High": {
    id: "app.components.RemoteTesting.specifications.High",
  },
})
